module.exports = __webpack_public_path__ + "img/seven1Green.ce7fdfb3.jpg";